module.exports = __webpack_public_path__ + "302e15066e68a7436f95f28cf8cbed59.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/4.png
// module id = 302
// module chunks = 0